import { render, staticRenderFns } from "./formA.vue?vue&type=template&id=690b84c8&scoped=true&"
import script from "./formA.vue?vue&type=script&lang=js&"
export * from "./formA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b84c8",
  null
  
)

export default component.exports